import { useState, useEffect } from 'react';
import './Waterways.css';
import Waterways from './Waterways';
import 'react-toastify/dist/ReactToastify.css';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "draft-js/dist/Draft.css";

const WaterwaysRisk = ({ handleWizardChanged, handleWizardChangedBack, handleMoveToNextPage }) => {

    const [waterways, setWaterways] = useState({
        Section: 'WaterwaysRisk', SectionName: 'Waterways', IsMapOnly: false, IsMapRisk: false
    });

    useEffect(() => {
        OnPageload();
    }, [])
    const OnPageload = async (e) => {

    }

    return (
        <div>
            <Waterways handleWizardChanged={handleWizardChanged} handleWizardChangedBack={handleWizardChangedBack} handleMoveToNextPage={handleMoveToNextPage} pageSection={waterways} ></Waterways>
        </div>
    )
}
export default WaterwaysRisk;